var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 7 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.219873 1.80652C-0.0732911 1.51335 -0.0732911 1.03804 0.219873 0.744875C0.513038 0.45171 0.988351 0.45171 1.28151 0.744875L6.00631 5.46967C6.2992 5.76257 6.2992 6.23744 6.00631 6.53033L1.28151 11.2551C0.988351 11.5483 0.513038 11.5483 0.219873 11.2551C-0.0732911 10.962 -0.0732911 10.4867 0.219873 10.1935L4.41336 6L0.219873 1.80652Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/chevron-right.333bb10dba34642fa4e673f254f34de8.svg";
export { ForwardRef as ReactComponent };